import React from 'react';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';

const UpgradeModal = ({ isOpen, onRequestClose, title, message }) => {
  const navigate = useNavigate();

  return (
    <Modal
      className="upgrade-prompt"
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel={title}
    >
      <h2>{title}</h2>
      <p>{message}</p>
      <div className="actions">
        <button onClick={onRequestClose}>Maybe later</button>
        <button
          onClick={() => {
            onRequestClose();
            navigate('/pricing');
          }}
        >
          Upgrade
        </button>
      </div>
    </Modal>
  );
};

export default UpgradeModal;